import React, { Component } from "react"
import { Link } from "react-router-dom"
import * as path from "../constants/Paths"
import { instanceOf } from "prop-types"
import { withCookies, Cookies } from "react-cookie"
import LoginLink from "./common/loginLink"
import * as endpoint from "../constants/Endpoints"
import * as tracking from "../../booking/helpers/tracking"

import config from "react-global-configuration"
import SiteHeader from "../../styleguide/js/components/site-header"

class ProgressIndicator extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  }
  constructor(props) {
    super(props)
    this.containerRef = React.createRef()
    this.state = {
      isMobileMenuActive: false,
      isMobileLoginDropdownActive: false,
      isLoginActive: false,
    }
  }
  componentDidMount() {
    this.props.handleCurrentStep(this.props.step)
    new SiteHeader({ el: this.containerRef.current })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.step !== this.props.step) {
      this.props.handleCurrentStep(this.props.step)
    }
    const { isMobileMenuActive } = this.state
    const root = document.getElementsByTagName("html")[0]
    if (isMobileMenuActive) {
      root.classList.add("is-mobilenav-mode")
      root.classList.add("is-sticky-mode")
    } else {
      if (root.classList.contains("is-mobilenav-mode")) root.classList.remove("is-mobilenav-mode")
      if (root.classList.contains("is-sticky-mode")) root.classList.remove("is-sticky-mode")
    }
  }

  handleMobileMenuActiveToggle = () => {
    this.setState({ isMobileMenuActive: !this.state.isMobileMenuActive })
  }

  handleLoginDropdownToggle = () => {
    this.setState({ isMobileLoginDropdownActive: !this.state.isMobileLoginDropdownActive })
  }

  handleLogout = () => {
    this.props.handleLogOut()
    this.setState({ isMobileMenuActive: false })
  }

  getProgressClassName(step, currentStep) {
    if (step < currentStep) {
      return "is-complete"
    } else if (step === currentStep) {
      return "is-active"
    } else {
      return ""
    }
  }

  handleOnClick = (step, currentStep, event) => {
    if (this.getProgressClassName(step, currentStep) === "") {
      return event.preventDefault()
    } else {
      return true
    }
  }

  render() {
    //const [cookies, setCookie] = useCookies([cookieNames.LOGIN_HISTORY])
    const { userAccountDetails, showExtraServicesStep } = this.props
    const { step: currentStep } = this.props
    const { isMobileMenuActive, isMobileLoginDropdownActive } = this.state
    const textKeys = config.get("textKeys.progressIndicator") || {}
    const headerMenuTextKeys = config.get("textKeys.headerMenu") || {}
    const trackingStep = this.props.step + 1
    const editTime = this.props.editTime

    const bookingNumber = this.props.location.search.substr(this.props.location.search.indexOf("reference=") + 10)
    let editInfo
    if (editTime) {
      editInfo = (
        <nav className="edit-info">
          <p className="left">{textKeys.progressBarActiveEdit || "du redigerer"}</p>
          <p className="right">{bookingNumber}</p>
        </nav>
      )
    } else {
      editInfo = null
    }

    return (
      <div className="site-header-wrapper">
        <header className={`site-header js--site-header is-home ${isMobileMenuActive ? "is-sticky" : ""}`} ref={this.containerRef}>
          <nav className="checkout-navigation checkout-navigation--parking rm-this-class rm-this-class-hide-default">
            <a
              className="checkout-navigation__close button button--nav button--nav-underline"
              href={textKeys.infoLink || path.HOME()}
              onClick={() => tracking.trackParkingFlowClick("close booking", "step " + trackingStep, this.props)}
            >
              <span className="icon">
                <svg className="svg-icon svg-icon--arrowleft">
                  <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-arrowleft">
                    &nbsp;
                  </use>
                </svg>
              </span>
              <span className="text">{textKeys.closeBooking || "Luk booking"}</span>
            </a>
            <div className="checkout-navigation__steps">
              <ul>
                <li className="checkout-navigation__steps__item">
                  <Link
                    className={`button button--nav ${this.getProgressClassName(1, currentStep)}`}
                    onClick={(e) => this.handleOnClick(1, currentStep, e)}
                    to={`${path.SEARCH()}${this.props.location.search}`}
                  >
                    <span className="number">1</span>
                    <span className="text">{textKeys.step1 || "Vælg parkering"}</span>
                  </Link>
                </li>
                {showExtraServicesStep ? (
                  <li className="checkout-navigation__steps__item">
                    <Link
                      className={`button button--nav ${this.getProgressClassName(2, currentStep)}`}
                      onClick={(e) => this.handleOnClick(2, currentStep, e)}
                      to={`${path.EXTRA_SERVICES()}${this.props.location.search}`}
                    >
                      <span className="number">2</span>
                      <span className="text">{textKeys.step2 || "Bilpleje"}</span>
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {showExtraServicesStep ? (
                  <li className="checkout-navigation__steps__item">
                    <Link
                      className={`button button--nav ${this.getProgressClassName(3, currentStep)}`}
                      onClick={(e) => this.handleOnClick(3, currentStep, e)}
                      to={`${path.CHECKOUT()}${this.props.location.search}`}
                    >
                      <span className="number">3</span>
                      <span className="text">{textKeys.step3 || "Betalingsoplysninger"}</span>
                    </Link>
                  </li>
                ) : (
                  <li className="checkout-navigation__steps__item">
                    <Link
                      className={`button button--nav ${this.getProgressClassName(2, currentStep)}`}
                      onClick={(e) => this.handleOnClick(2, currentStep, e)}
                      to={`${path.CHECKOUT()}${this.props.location.search}`}
                    >
                      <span className="number">2</span>
                      <span className="text">{textKeys.step3 || "Betalingsoplysninger"}</span>
                    </Link>
                  </li>
                )}
              </ul>
            </div>

            <ul className="checkout-navigation__aux">
              <li className="main-navigation__item main-navigation__item--user">
                {userAccountDetails ? (
                  userAccountDetails.ContactDetails ? (
                    <React.Fragment>
                      {/* route to 'min side'? */}
                      <a className="button button--nav" href={headerMenuTextKeys.myPage}>
                        {/* {console.debug(textKeys.myPage)} */}
                        <span className="text name">
                          {userAccountDetails.ContactDetails.FirstName || userAccountDetails.ContactDetails.LastName
                            ? userAccountDetails.ContactDetails.FirstName + " " + userAccountDetails.ContactDetails.LastName
                            : userAccountDetails.EmailAddress}
                        </span>
                      </a>

                      {/* THERE'S NO LOG OUT BUTTON IN THE STYLEGUIDE */}
                      {/* <button className="button button--nav"
                      onClick={this.props.handleLogOut}
                    >
                      <span className="text">{textKeys.logout || "Log ud"}</span>
                    </button> */}
                    </React.Fragment>
                  ) : (
                    <div className="button button--nav">
                      <span className="text">{textKeys.crmOffline || "Sorry CRM is offline ..."}</span>
                    </div>
                  )
                ) : (
                  <LoginLink
                    {...this.props}
                    loginurl={endpoint.ACCOUNT_LOGIN()}
                    linkClassName={"button button--nav button--nav-underline"}
                    spanClassName={"text"}
                    linkText={textKeys.login || "Log ind"}
                    trackingHandler={() => tracking.trackCTALoginButtonClick("parking - booking flow header")}
                  />
                )}
              </li>
            </ul>
          </nav>

          {editInfo}
        </header>
      </div>
    )
  }
}

export default withCookies(ProgressIndicator)
